<template>
    <div style="width: 100%; height: 100%">
      <GmapMap ref="mapRef"
        :center="center"
        :zoom="defaultZoom"
        map-type-id="terrain"
        style="width: 100%; height: 100%"
        @click="infoWinOpen=false"
      >
        <GmapMarker
          :key="`marker${index}`"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :clickable="true"
          @click="toggleInfoWindow(m,index)"
        />
        <GmapPolyline :path="lineCoordinates" :options="currentPathPolyline"
            ref="polyline">
        </GmapPolyline>
        <GmapPolyline
          v-for="(path, index) in linePath"
          :key="'mark' + index"
          :path="path"
          :options="optionValue(path)"
          ref="polyline">
        </GmapPolyline>
        <GmapMarker
            :key="index"
            v-for="(m, index) in travelPath"
            :position="{lat: m.lat, lng: m.lng}"
            :icon="m.icon"
            :clickable="true"
            @click="toggleInfoWindow(m,index)"
        />
        <div v-if="showPopUp">
        <GmapInfoWindow :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false">
          <span v-html="infoContent" class="text-grey-dark"></span>
        </GmapInfoWindow>
      </div>
      </GmapMap>
      <div class="speed-container">
        <Row :gutter="12">
          <Col :span="6">
            <div class="speed-value">Average speed : <strong>{{averageSpeed}} km/hr</strong></div>
          </Col>
            <Col :span="4">
              <div class="speed-chart speed-average">
                  <div class="speed-bar" style="width: 50%;"></div>
                    <span class="speed-bar-text">
                      0 - 20 km/hr
                    </span>
              </div>
            </Col>
            <Col :span="4">
              <div class="speed-chart speed-medium">
                  <div class="speed-bar" style="width: 50%;"></div>
                    <span class="speed-bar-text">
                      21 - 45 km/hr
                    </span>
              </div>
              </Col>
              <Col :span="4">
                <div class="speed-chart speed-high">
                  <div class="speed-bar" style="width: 50%;"></div>
                    <span class="speed-bar-text">
                      46 - 65 km/hr
                    </span>
                </div>
              </Col>
            <Col :span="4">
              <div class="speed-chart speed-super-high">
                <div class="speed-bar" style="width: 50%;"></div>
                  <span class="speed-bar-text">
                    &#62; 65 km/hr
                  </span>
              </div>
            </Col>
        </Row>
      </div>
    </div>
</template>

<script>
import TruckIcon from '@common/asset/images/truck.svg';
import SourceIcon from '@common/asset/images/source.svg';
import DestinationIcon from '@common/asset/images/destination.svg';
import DotIcon from '@common/asset/images/dot.svg';
import HaltIcon from '@common/asset/images/halt.svg';
import calculateHaversineDistance from '@/lib/haversine-method';

export default {
  props: {
  },
  data() {
    return {
      currentConsignee: null,
      TruckIcon,
      icons: { source: SourceIcon, destination: DestinationIcon },
      DotIcon,
      HaltIcon,
      consigneesMap: {},
      center: {
      },
      markers: [],
      travelPath: [],
      drops: [],
      paths: [],
      currentPlace: null,
      isMapLoading: false,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -25,
        },
      },
      currentPathPolyline: {
        strokeColor: '#008AFF',
        strokeWeight: 3,
        zIndex: 10,
      },
      currentMidx: null,
      averageSpeed: 'NA',
      mapData: null,
      lineCoordinates: [],
      linePath: [],
      defaultZoom: 13,
      showPopUp: true,
      truckPosition: null,
      truckZoom: 18,
    };
  },
  created() {
    this.mapData = this.$session.get('mapData');
    if (this.mapData) {
      const locationList = [];
      const { source, destination, locations = [] } = this.mapData;
      this.paths = locations.map(_location => ({
        lat: _location.lat,
        lng: _location.lon,
        position: {
          lat: _location.lat,
          lng: _location.lon,
        },
        locationDetails: {
          haltTime: _location.haltTime,
        },
        icon: `${this.DotIcon}`,
        created_at: new Date(_location.createdAt),
        trackingType: _location.trackingType || null,
        address: _location.address || null,
        formattedDate: _location.formattedDate || null,
      }));
      if (Array.isArray(source)) {
        source.forEach(val => locationList.push(this.getLatLong(val, 'source')));
      } else {
        locationList.push(this.getLatLong(source, 'source'));
      }
      if (Array.isArray(destination)) {
        destination.forEach(val => locationList.push(this.getLatLong(val, 'destination')));
      } else {
        locationList.push(this.getLatLong(destination, 'destination'));
      }
      const lastLocation = this.paths[0];
      if (lastLocation) {
        locationList.push({
          position: lastLocation,
          icon: `${this.TruckIcon}`,
          created_at: new Date(lastLocation.created_at),
        });
        this.truckPosition = { lat: lastLocation.lat, lng: lastLocation.lng };
      }
      this.center = lastLocation;
      this.markers = locationList;
      this.lineCoordinates = this.paths;
    }
    this.defaultZoom = (this.mapData && this.truckPosition)
      ? this.truckZoom
      : (this.mapData && this.mapData.mapSettings && this.mapData.mapSettings.gmap_zoom);
  },
  mounted() {
    this.displayHaltAndSpeed();
  },
  methods: {
    escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    displayHaltAndSpeed() {
      let cumulativeSpeed = 0;
      const { haltThreshold } = this.mapData;

      for (let index = 0; index < (this.paths.length - 1); index += 1) {
        let speed = 0;
        const distanceInMetres = this.getDistanceInMetres(this.paths[index], this.paths[index + 1]);
        const distanceInKm = distanceInMetres / 1000;
        const seconds = this.getTimeInSeconds(this.paths[index].created_at, this.paths[index + 1].created_at);
        const minutes = parseInt(seconds / 60);
        if (seconds) {
          speed = (distanceInMetres / seconds) * (18 / 5);
          cumulativeSpeed += speed;
        }
        this.paths[index].speed = speed;
        if (distanceInKm < haltThreshold && minutes >= 15) {
          this.paths[index].icon = `${this.HaltIcon}`;
          this.paths[index].haltTime = minutes;
        }
        this.linePath.push([this.paths[index], this.paths[index + 1]]);
      }
      this.averageSpeed = parseInt(cumulativeSpeed / this.paths.length);
      this.travelPath = this.paths;
      if (this.travelPath.length > 1) {
        this.travelPath.shift();
      }
    },
    closeMenu() {
      this.$emit('close');
    },
    optionValue(ping) {
      const speed = ping[0].speed;
      let colour;
      switch (true) {
        case speed <= 10:
          colour = '#DA70D6'; // pink
          break;
        case speed <= 19:
          colour = '#4B0082'; // Violet
          break;
        case speed <= 33:
          colour = '#3CB371'; // light green
          break;
        case speed <= 45:
          colour = '#006400'; // Dark Green
          break;
        case speed <= 65:
          colour = '#FFA203'; // Orange
          break;
        default:
          colour = '#FF0000'; // Red
          break;
      }
      return {
        strokeColor: colour,
        strokeWeight: 3,
        zIndex: 10,
      };
    },
    getLatLong(data, section) {
      return {
        position: {
          lat: data.lat,
          lng: data.lon,
        },
        icon: `${this.icons[section]}`,
        details: {
          label: section,
          name: data[section] || '',
        },
      };
    },
    getDistanceInMetres(currentping, previousPing) {
      const distance = calculateHaversineDistance(currentping.lat, currentping.lng,
        previousPing.lat, previousPing.lng);
      return distance;
    },
    getTimeInSeconds(currentPingDate, previousPingDate) {
      const diffInMilliSeconds = Math.abs(new Date(currentPingDate) - new Date(previousPingDate));
      const seconds = Math.floor(diffInMilliSeconds / 1000);
      return seconds;
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '';
      if (marker.details) {
        this.showPopUp = true;
        this.infoContent = `
          <div style="background:rgba(30,30,30,0.82);color:#fff;padding:10px 14px;border-radius:6px;font-size:13px;line-height:1.7;min-width:160px;">
            <b>${this.escapeHtml(marker.details.label)}:</b> ${this.escapeHtml(marker.details.name)}
          </div>`;
      } else if (marker.icon === `${this.HaltIcon}`) {
        this.showPopUp = true;
        this.infoContent = `
          <div style="background:rgba(30,30,30,0.82);color:#fff;padding:10px 14px;border-radius:6px;font-size:13px;line-height:1.7;">
            Halt for <b>${this.escapeHtml(marker.haltTime)}</b> minutes
          </div>`;
      } else {
        const trackingIconMap = { SIM: '&#128246;', GPS: '&#128225;', APP: '&#128241;' };
        const trackingLabelMap = { SIM: 'SIM Tracking', GPS: 'GPS Tracking', APP: 'App Tracking' };
        const trackingIcon = marker.trackingType ? (trackingIconMap[marker.trackingType] || '') : '';
        const trackingLabel = marker.trackingType ? (trackingLabelMap[marker.trackingType] || this.escapeHtml(marker.trackingType)) : '';
        const pingLine = [
          marker.formattedDate ? this.escapeHtml(marker.formattedDate) : null,
          marker.speed ? `${parseInt(marker.speed, 10)} km/hr` : null,
          trackingLabel ? `${trackingIcon} ${trackingLabel}` : null,
        ].filter(Boolean).join(' &nbsp;|&nbsp; ');

        if (pingLine || marker.address) {
          this.showPopUp = true;
          this.infoContent = `
            <div style="background:rgba(30,30,30,0.82);color:#fff;padding:10px 14px;border-radius:6px;font-size:13px;line-height:1.7;min-width:220px;">
              ${pingLine ? `<div><b>Ping Received :</b> ${pingLine}</div>` : ''}
              ${marker.address ? `<div><b>Location :</b> ${this.escapeHtml(marker.address)}</div>` : ''}
            </div>`;
        } else {
          this.showPopUp = false;
        }
      }
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      this.center = marker.position;
    },

  },
};
</script>
<style lang="scss" scoped>
.no-location-text {
  color: #6D8EB4;
  display: inline-block;
  margin-left: 20px;
  font-size: 18px;
  font-weight: 300;
}
.vue-map-container{
  position:absolute !important ;
}

</style>

<style>
/* Remove Google Maps InfoWindow white bubble */
.gm-style-iw-c {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}
.gm-style-iw-d {
  overflow: hidden !important;
  padding: 0 !important;
}
/* Dark arrow */
.gm-style-iw-tc::after {
  background: linear-gradient(45deg, rgba(30,30,30,0.82) 50%, rgba(30,30,30,0) 51%, rgba(30,30,30,0) 100%) !important;
  box-shadow: none !important;
}
.gm-style-iw-tc {
  filter: none !important;
}
/* Hide all close button variations */
.gm-style-iw > button,
.gm-style-iw button,
.gm-style-iw-ch,
.gm-style-iw-chr,
.gm-ui-hover-effect,
.gm-ui-hover-effect span,
.gm-style-iw-c > button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}
</style>
